var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMondayProjectsSquare = function SvgMondayProjectsSquare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    fill: "none",
    viewBox: "0 0 72 72"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_linear_1371_406878)",
    d: "M25.313 22.034c0-.996.526-1.916 1.38-2.414l7.927-4.622a2.74 2.74 0 0 1 2.76 0l7.928 4.622a2.79 2.79 0 0 1 1.38 2.414v10.853l-10.687 6.231-10.687-6.231z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint1_linear_1371_406878)",
    d: "M25.313 32.888c-3.096 1.815-6.205 3.611-9.307 5.42a2.79 2.79 0 0 0-1.381 2.415v9.243c0 .996.526 1.916 1.38 2.414l7.927 4.621a2.74 2.74 0 0 0 2.761 0l9.308-5.42V39.119z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint2_linear_1371_406878)",
    d: "M55.994 38.308a2.79 2.79 0 0 1 1.38 2.415v9.243c0 .996-.526 1.916-1.38 2.414l-7.926 4.621a2.74 2.74 0 0 1-2.761 0l-9.308-5.42V39.12l10.688-6.231c3.097 1.816 6.206 3.612 9.307 5.42"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint3_linear_1371_406878)",
    d: "M25.313 33.692c0-.498.263-.958.69-1.207l9.307-5.426a1.37 1.37 0 0 1 1.38 0l9.307 5.426c.427.25.69.71.69 1.207v10.853c0 .498-.263.958-.69 1.207l-9.307 5.426a1.37 1.37 0 0 1-1.38 0l-9.307-5.426a1.4 1.4 0 0 1-.69-1.207z",
    style: {
      mixBlendMode: "multiply"
    }
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1371_406878",
    x1: 25.313,
    x2: 46.783,
    y1: 20.44,
    y2: 32.725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB9000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCB00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1371_406878",
    x1: 36,
    x2: 14.53,
    y1: 39.108,
    y2: 51.393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB9000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCB00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1371_406878",
    x1: 36,
    x2: 57.47,
    y1: 39.108,
    y2: 51.393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB9000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCB00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1371_406878",
    x1: 36,
    x2: 36,
    y1: 26.872,
    y2: 51.365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDAB3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCB00",
    stopOpacity: 0.51
  })))));
};
export default SvgMondayProjectsSquare;